import req from "../modules/request.module";
import { INVESTORS_COUNT_ACTIVE } from "../actions/types";
import { notify } from "../components/framework/notify";
import i18n from "@/i18n";

export function countActiveInvestments() {
  return async function (dispatch) {
    try {
      const response = await req.get(
        "/shares/company/investments/count/active",
      );
      dispatch({
        type: INVESTORS_COUNT_ACTIVE,
        payload: response.data.numOfActiveShareholders,
      });
    } catch (error) {
      console.error(error);
      notify("error", i18n.t("investment.error.count_active_investments"));
    }
  };
}
